import { Card as AntCard } from "antd";
import type { CardProps as AntCardProps } from "antd";
import * as React from "react";
import { cn } from "@/shared/lib/utils";

export function Card({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <AntCard
      hoverable
      className={cn("!rounded-xl !border-[#DAD9D8] !shadow-sm", className)}
      styles={{ body: { padding: 16 } }} // p-4
      {...(props as AntCardProps)}
    >
      {children}
    </AntCard>
  );
}

export function CardHeader({ className, children, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("mb-3", className)} {...props}>{children}</div>;
}

export function CardTitle({ className, children, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("text-base font-semibold text-[#3A3D42]", className)} {...props}>{children}</div>;
}

export function CardDescription({ className, children, ...props }: React.ComponentProps<"p">) {
  return <p className={cn("text-sm text-[#75787B]", className)} {...props}>{children}</p>;
}

export function CardContent({ className, children, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("", className)} {...props}>{children}</div>;
}

export function CardFooter({ className, children, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("mt-4 flex items-center gap-2", className)} {...props}>{children}</div>;
}